var _ = require('underscore');

var ClassNames = function () {
  var classes = {};
  _.each(arguments, function (className) {
    if (className) {
      if (_.isFunction(className)) {
        _.extend(classes, ClassNames(className()));
      } else if (_.isArray(className)) {
        _.extend(classes, ClassNames.apply(null, className));
      } else if (_.isObject(className)) {
        _.extend(classes, className);
      } else {
        classes[className] = true;
      }
    }
  });
  return classes;
};

module.exports = {
  ClassNames: ClassNames
};



// WEBPACK FOOTER //
// ./src/app/components/utils.jsx